<template>
  <div style="min-width: 1400px">
    <!--<div class="spaceBetweenBox approvalBox" @click="toWorkbenchApproval">-->
    <!--<div class="flexStartBox">-->
    <!--<el-badge :value="pendingApprovalTotal" class="approvalBgBox">-->
    <!--<div>-->
    <!--<i class="iconfont el-icon-damai-shenpi3" style="color: #0e9cfb;"></i>-->
    <!--</div>-->
    <!--</el-badge>-->
    <!--<div style="font-size: 16px;">我的审批</div>-->
    <!--</div>-->

    <!--<div class="toAllApprovalList"  style="font-size: 16px;">-->
    <!--查看全部审批列表<i class="el-icon-arrow-right" style="margin-left: 10px;"></i><i class="el-icon-arrow-right"></i>-->
    <!--</div>-->
    <!--</div>-->

    <div class="home-to-link-box">
      <div class="home-to-link-line-box">
        <h3>新运营</h3>
        <div class="home-to-link-line">
          <div
            class="home-to-link-item"
            v-for="item in topList"
            :key="item.name"
            @click="
              toLinkPage(item.router, item.str, item.isShow, item.authCode)
            "
          >
            <div
              class="home-to-link-item-mask"
              v-if="item.isShow === '0'"
            ></div>
            <img :src="item.src" class="home-to-link-item-img" />
            <div class="home-to-link-item-text">{{ item.name }}</div>
          </div>
        </div>
      </div>

      <div class="home-to-link-line-half-list">
        <div class="home-to-link-line-half-box">
          <h3>新物业</h3>
          <div class="home-to-link-line">
            <div
              class="home-to-link-item"
              v-for="item in propertyList"
              :key="item.name"
              @click="
                toLinkPage(item.router, item.str, item.isShow, item.authCode)
              "
            >
              <div
                class="home-to-link-item-mask"
                v-if="item.isShow === '0'"
              ></div>
              <img :src="item.src" class="home-to-link-item-img" />
              <div class="home-to-link-item-text">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="home-to-link-line-half-box">
          <h3>新通行</h3>
          <div class="home-to-link-line">
            <div
              class="home-to-link-item"
              v-for="item in generalList"
              :key="item.name"
              @click="
                toLinkPage(item.router, item.str, item.isShow, item.authCode)
              "
            >
              <div
                class="home-to-link-item-mask"
                v-if="item.isShow === '0'"
              ></div>
              <img :src="item.src" class="home-to-link-item-img" />
              <div class="home-to-link-item-text">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="home-to-link-line-half-box">
          <h3>新财务</h3>
          <div class="home-to-link-line">
            <div
              class="home-to-link-item"
              v-for="item in financeList"
              :key="item.name"
              @click="
                toLinkPage(item.router, item.str, item.isShow, item.authCode)
              "
            >
              <div
                class="home-to-link-item-mask"
                v-if="item.isShow === '0'"
              ></div>
              <img :src="item.src" class="home-to-link-item-img" />
              <div class="home-to-link-item-text">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="home-to-link-line-half-box">
          <h3>新能耗</h3>
          <div class="home-to-link-line">
            <div
              class="home-to-link-item"
              v-for="item in energyConsumptionList"
              :key="item.name"
              @click="
                toLinkPage(item.router, item.str, item.isShow, item.authCode)
              "
            >
              <div
                class="home-to-link-item-mask"
                v-if="item.isShow === '0'"
              ></div>
              <img :src="item.src" class="home-to-link-item-img" />
              <div class="home-to-link-item-text">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="home-to-link-line-half-box">
          <h3>新企服</h3>
          <div class="home-to-link-line">
            <div
              class="home-to-link-item"
              v-for="item in enterpriseServiceList"
              :key="item.name"
              @click="
                toLinkPage(item.router, item.str, item.isShow, item.authCode)
              "
            >
              <div
                class="home-to-link-item-mask"
                v-if="item.isShow === '0'"
              ></div>
              <img :src="item.src" class="home-to-link-item-img" />
              <div class="home-to-link-item-text">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="home-to-link-line-half-box">
          <h3>新安全</h3>
          <div class="home-to-link-line">
            <div
              class="home-to-link-item"
              v-for="item in securityList"
              :key="item.name"
              @click="
                toLinkPage(item.router, item.str, item.isShow, item.authCode)
              "
            >
              <div
                class="home-to-link-item-mask"
                v-if="item.isShow === '0'"
              ></div>
              <img :src="item.src" class="home-to-link-item-img" />
              <div class="home-to-link-item-text">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../api/Workbench";
import { nSuccess } from "../../utils/notice";
import { errorHandler } from "../../utils/errorHandler";
import { bus } from "../../utils/bus";

export default {
  name: "workbench",
  data() {
    return {
      homeData: "",
      tableData: [],

      pendingApprovalTotal: 0,
      accountCode: "",
      total: 1,
      capitalValue: true,
      pageSize: 6,

      // 逾期未结算客户相关字段
      dueOverTotal: 0,
      dueOverPageSize: 5,
      dueOverPageNum: 1,
      dueOverTableData: [],

      // 账单跟进相关字段
      fellowBillTotal: 0,
      fellowBillPageSize: 5,
      fellowBillPageNum: 1,
      fellowBillList: [],

      // 近30天资金流水统计
      fellowLegendData: [],
      fellowXData: [],
      moneyFellowList: [],
      countFellowList: [],

      colorList: [
        "#37A2DA",
        "#32C5E9",
        "#9FE6B8",
        "#FF9F7F",
        "#FB7293",
        "#E7BFF3",
      ],

      permissionCodes: "",
      showBtnList: [
        [
          {
            name: "园区公告",
            icon: "el-icon-damai-gonggao",
            router: "yq-notice-management",
            fontSize: "24px",
            str: "resource",
            authCode: "001002000",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "园区资讯",
            icon: "el-icon-damai-zixun",
            router: "yq-zx-manage",
            fontSize: "24px",
            str: "resource",
            authCode: "001002004",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "房屋管理",
            icon: "el-icon-damai-fangyuan",
            router: "housing-management",
            fontSize: "24px",
            str: "resource",
            authCode: "001003000",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "住户管理",
            icon: "el-icon-damai-qiye",
            router: "business-management",
            fontSize: "24px",
            str: "resource",
            authCode: "001004000",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "人员管理",
            icon: "el-icon-damai-renyuan",
            router: "person-management",
            str: "resource",
            fontSize: "24px",
            authCode: "001005000",
            isShow: "1",
            showInPage: false,
          },
        ],
        [
          {
            name: "智慧门禁",
            icon: "el-icon-damai-access",
            router: "accessCtrlDeviceManagementCenter",
            fontSize: "24px",
            str: "application",
            authCode: "003",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "智慧停车",
            icon: "el-icon-damai-socar_parking_icon",
            router: "parking-device-management",
            fontSize: "24px",
            str: "application",
            authCode: "004",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "智慧用电",
            icon: "el-icon-damai-liuliang",
            router: "electronic-over-view",
            fontSize: "24px",
            str: "application",
            authCode: "005",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "智慧梯控",
            icon: "el-icon-damai-dianti1",
            router: "ladder-device",
            fontSize: "28px",
            str: "application",
            authCode: "009",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "智慧访客",
            icon: "el-icon-damai-fangke1",
            router: "visitor-device-manage",
            fontSize: "24px",
            str: "application",
            authCode: "007",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "智慧预约",
            icon: "el-icon-damai-changdi-tianchong",
            router: "site-management",
            fontSize: "24px",
            str: "application",
            authCode: "008",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "智慧报修",
            icon: "el-icon-damai-xiugai",
            router: "repair-category-manage",
            fontSize: "24px",
            str: "application",
            authCode: "011",
            isShow: "1",
            showInPage: false,
          },
        ],
        [
          {
            name: "客户管理",
            icon: "el-icon-damai-kehuguanli",
            router: "custom-management",
            str: "application",
            fontSize: "24px",
            authCode: "002001000",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "合同管理",
            icon: "el-icon-damai-fangwuzujin",
            router: "contract-management",
            str: "application",
            fontSize: "24px",
            authCode: "002002000",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "租金管理",
            icon: "el-icon-damai-hetong1",
            router: "rent-management",
            fontSize: "24px",
            str: "application",
            authCode: "002003000",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "物业费管理",
            icon: "el-icon-damai-wuyefeiyongchuzhang",
            router: "property-management",
            fontSize: "24px",
            str: "application",
            authCode: "002003000",
            isShow: "1",
            showInPage: false,
          },
          {
            name: "保证金及其他",
            icon: "el-icon-damai-yajin",
            router: "deposit-management",
            fontSize: "24px",
            str: "application",
            authCode: "002004000",
            isShow: "1",
            showInPage: false,
          },
        ],
      ],

      topList: [
        {
          name: "智慧大脑",
          src: require("../../assets/home_png/zhdn.png"),
          router: "interface-manage",
          authCode: "028",
          str: "application",
          isShow: "1",
        },
        {
          name: "公告资讯",
          src: require("../../assets/home_png/ggzx.png"),
          router: "yq-notice-management",
          authCode: "001002000",
          str: "resource",
          isShow: "1",
        },
        {
          name: "房产管理",
          src: require("../../assets/home_png/fcgl.png"),
          router: "housing-management",
          authCode: "001003000",
          str: "resource",
          isShow: "1",
        },
        {
          name: "智慧合约",
          src: require("../../assets/home_png/zhzs.png"),
          router: "investment-over-view",
          authCode: "002",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧招商",
          src: require("../../assets/home_png/zhjjr.png"),
          router: "investment-manage",
          authCode: "017",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧消息",
          src: require("../../assets/home_png/zhxx.png"),
          router: "message-template-manage",
          authCode: "006",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧文书",
          src: require("../../assets/home_png/zhws.png"),
          router: "contract-template",
          authCode: "015",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧活动",
          src: require("../../assets/home_png/zhhd.png"),
          router: "activity-manage",
          authCode: "019",
          str: "application",
          isShow: "1",
        },
      ],
      generalList: [
        {
          name: "智慧访客",
          src: require("../../assets/home_png/zhfk.png"),
          router: "visitor-over-view",
          authCode: "007",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧门禁",
          src: require("../../assets/home_png/zhmj.png"),
          router: "accessCtrlDeviceManagementCenter",
          authCode: "003",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧梯控",
          src: require("../../assets/home_png/zhtk.png"),
          router: "ladder-over-view",
          authCode: "009",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧停车",
          src: require("../../assets/home_png/zhtc.png"),
          router: "park-over-view",
          authCode: "004",
          str: "application",
          isShow: "1",
        },
      ],
      enterpriseServiceList: [
        {
          name: "企业管理",
          src: require("../../assets/home_png/qygl.png"),
          router: "business-management",
          authCode: "001004000",
          str: "resource",
          isShow: "1",
        },
        {
          name: "智慧预约",
          src: require("../../assets/home_png/zhyy.png"),
          router: "site-over-view",
          authCode: "008",
          str: "application",
          isShow: "1",
        },
        {
          name: "严选服务",
          src: require("../../assets/home_png/yxfw.png"),
          router: "service-over-view",
          authCode: "018",
          str: "application",
          isShow: "1",
        },
      ],
      propertyList: [
        {
          name: "智慧报修",
          src: require("../../assets/home_png/zhbx.png"),
          router: "repair-over-view",
          authCode: "011",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧巡更",
          src: require("../../assets/home_png/zhxg.png"),
          router: "patrol-point-manage",
          authCode: "025",
          str: "application",
          isShow: "1",
        },
        {
          name: "设备巡检",
          src: require("../../assets/home_png/sbxj.png"),
          router: "inspection-device-type-manage",
          authCode: "024",
          str: "application",
          isShow: "1",
        },
        {
          name: "智能机器人",
          src: require("../../assets/home_png/znjqr.png"),
          router: "",
          authCode: "",
          str: "application",
          isShow: "0",
        },
      ],
      financeList: [
        {
          name: "智慧财务",
          src: require("../../assets/home_png/zhcw.png"),
          router: "finance-over-view",
          authCode: "013",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧缴费",
          src: require("../../assets/home_png/zhjf.png"),
          router: "custom-payment-manage",
          authCode: "014",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧凭证",
          src: require("../../assets/home_png/zhfp.png"),
          router: "invoice-over-view",
          authCode: "016",
          str: "application",
          isShow: "1",
        },
      ],
      energyConsumptionList: [
        {
          name: "智慧用电",
          src: require("../../assets/home_png/zhyd.png"),
          router: "electronic-over-view",
          authCode: "005",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧用水",
          src: require("../../assets/home_png/zhys.png"),
          router: "water-over-view",
          authCode: "027",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧空调",
          src: require("../../assets/home_png/zhkt.png"),
          router: "air-conditioning-gateway-device",
          authCode: "023",
          str: "application",
          isShow: "1",
        },
      ],
      securityList: [
        {
          name: "智慧监控",
          src: require("../../assets/home_png/zhjk.png"),
          router: "video-device",
          authCode: "020",
          str: "application",
          isShow: "1",
        },
        {
          name: "智慧消防",
          src: require("../../assets/home_png/zhxf.png"),
          router: "fire-over-view",
          authCode: "021",
          str: "application",
          isShow: "1",
        },
        {
          name: "报警中心",
          src: require("../../assets/home_png/bjzx.png"),
          router: "alarm-device-manage",
          authCode: "022",
          str: "application",
          isShow: "1",
        },
      ],
    };
  },
  created() {
    this.accountCode = bus.global.accountCode;
    this.permissionCodes = bus.global.permissionCodes;
    this.getYqServerConfig();
  },
  mounted() {
    // this.getHomeData()
    // this.getBuildingList()
    this.getCountApproveForMe();
    // // 30天内可收
    // this.getDueInItems()
    // // 合同跟进
    // this.getContractListGroupByFellower()
    // // 逾期未结算客户
    // this.getDueOverItems()
    // // 账单跟进
    // this.getFellowBillList()
    // // 资金流水
    // this.getmoneyFellowList()
    // // 新增客户统计
    // this.getIncreaseCustomStatistics()
    // // 合同签订及退租统计
    // this.getOverDateContractListDetail()
  },
  methods: {
    // 页面跳转
    toLinkPage(routerName, str, state, authCode) {
      if (state === "0") {
        this.$confirm(
          "暂未开通此功能，若想使用此服务请联系官方客服0571-81606226。"
        );
        return false;
      } else {
        if (this.permissionCodes.indexOf(authCode) === -1) {
          this.$confirm("您暂无查看此功能的权限。");
          return false;
        } else {
          window.sessionStorage.setItem("navTop", str);
          this.$router.push({
            name: routerName,
          });
        }
      }
    },

    // 获取服务配置数据
    getYqServerConfig() {
      this.$axios
        .post(api.getYqServerConfig, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map((v) => {
              // topList
              if (v.configValue === "PF") {
                // 招商
                this.showBtnList[2].map((zs) => {
                  zs.isShow = v.configStatus;
                });
                this.topList[3].isShow = v.configStatus;
              }
              if (v.configValue === "PM") {
                // 智慧招商
                this.topList[4].isShow = v.configStatus;
              }
              if (v.configValue === "PQ") {
                // 智慧消息
                this.topList[5].isShow = v.configStatus;
              }
              if (v.configValue === "PP") {
                // 智慧文书
                this.topList[6].isShow = v.configStatus;
              }
              if (v.configValue === "PS") {
                // 智慧活动
                this.topList[7].isShow = v.configStatus;
              }

              // generalList
              if (v.configValue === "PA") {
                // 访客
                this.showBtnList[1][4].isShow = v.configStatus;
                this.generalList[0].isShow = v.configStatus;
              }
              if (v.configValue === "PG") {
                // 门禁
                this.showBtnList[1][0].isShow = v.configStatus;
                this.generalList[1].isShow = v.configStatus;
              }
              if (v.configValue === "PB") {
                // 梯控
                this.showBtnList[1][3].isShow = v.configStatus;
                this.generalList[2].isShow = v.configStatus;
              }
              if (v.configValue === "PC") {
                // 停车
                this.showBtnList[1][1].isShow = v.configStatus;
                this.generalList[3].isShow = v.configStatus;
              }

              // energyConsumptionList
              if (v.configValue === "PD") {
                // 电控
                this.showBtnList[1][2].isShow = v.configStatus;
                this.energyConsumptionList[0].isShow = v.configStatus;
              }
              if (v.configValue === "QA") {
                // 水控
                this.energyConsumptionList[1].isShow = v.configStatus;
              }
              if (v.configValue === "PW") {
                // 空调
                this.energyConsumptionList[2].isShow = v.configStatus;
              }

              if (v.configValue === "PE") {
                // 基础
                this.showBtnList[0].map((jc) => {
                  jc.isShow = v.configStatus;
                });
              }

              // enterpriseServiceList
              if (v.configValue === "PH") {
                // 预约
                this.showBtnList[1][5].isShow = v.configStatus;
                this.enterpriseServiceList[1].isShow = v.configStatus;
              }
              if (v.configValue === "PR") {
                // 严选服务
                this.enterpriseServiceList[2].isShow = v.configStatus;
              }

              // propertyList
              if (v.configValue === "PL") {
                // 报修
                this.showBtnList[1][6].isShow = v.configStatus;
                this.propertyList[0].isShow = v.configStatus;
              }
              if (v.configValue === "PY") {
                // 智慧巡更
                this.propertyList[1].isShow = v.configStatus;
              }
              if (v.configValue === "PX") {
                // 设备巡检
                this.propertyList[1].isShow = v.configStatus;
              }

              // financeList
              if (v.configValue === "PJ") {
                // 智慧财务
                this.financeList[0].isShow = v.configStatus;
              }
              if (v.configValue === "PO") {
                // 智慧缴费
                this.financeList[1].isShow = v.configStatus;
              }
              if (v.configValue === "PN") {
                // 智慧凭证
                this.financeList[2].isShow = v.configStatus;
              }

              // securityList
              if (v.configValue === "PU") {
                // 智慧监控
                this.securityList[0].isShow = v.configStatus;
              }
              if (v.configValue === "PT") {
                // 智慧消防
                this.securityList[1].isShow = v.configStatus;
              }
              if (v.configValue === "PV") {
                // 报警中心
                this.securityList[2].isShow = v.configStatus;
              }
            });
          }
        })
        .catch(errorHandler("查询公寓服务状态失败"));
    },

    getBuildingList() {
      this.$axios
        .post(api.getBuildingList, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            data.map((v) => {
              for (let i in v) {
                if (v[i] !== 0) {
                  if (!v[i]) {
                    v[i] = "--";
                  }
                }
              }
            });
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取楼栋数据失败"));
    },
    buildingRowClick(row) {
      window.sessionStorage.setItem(
        "housingManagementPageBuildingTabState",
        row.code
      );
      window.sessionStorage.setItem(
        "housingManagementPageHousingTabState",
        "housing_resources"
      );
      window.sessionStorage.setItem("navTop", "resource");
      this.$router.push({
        name: "housing-management",
      });
    },
    getHomeData() {
      this.$axios
        .post(api.getHomeData, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            this.homeData = res.data.data;
          }
        })
        .catch(errorHandler("查询信息失败"));
    },
    toWorkbenchApproval() {
      this.$router.push({
        name: "workbench-approval",
      });
    },
    // 获取审批数量
    getCountApproveForMe() {
      this.$axios
        .post(api.getCountApproveForMe, {
          approveAccountCode: this.accountCode,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            this.pendingApprovalTotal = res.data.data;
          }
        })
        .catch(errorHandler("获取审批数据失败"));
    },
    // 待我审批
    getPendingApprovalPage() {
      let reqData = {};
      reqData.pageNum = "1";
      reqData.pageSize = "10";
      reqData.approveAccountCode = this.accountCode;
      reqData.approveStatus = "0";
      this.$axios
        .post(api.getPageByApproveAccountCode, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            this.pendingApprovalTotal = res.data.data.total;
          }
        })
        .catch(errorHandler("获取待我审批数据失败"));
    },
  },
  watch: {},
};
</script>

<style scoped>
.main_title {
  text-align: left;
  font-size: 20px;
  color: #333;
  padding-top: 2px;
  padding-left: 10px;
  border-left: 5px solid #00a0e6;
  margin: 10px 0 20px;
  font-weight: 400;
}
.box-line {
  padding: 5px 10px;
  border: 1px solid #dddddd;
  border-radius: 10px;
}

#dueInItems,
#contract_follow,
#capital_flow {
  text-align: left;
}

.spaceBetweenBox {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.approvalBox {
  font-size: 18px;
  line-height: 70px;
  background-color: #0e9cfb;
  margin: 0 -20px;
  padding: 0 20px;
  color: #ffffff;
}

.toAllApprovalList:hover {
  cursor: pointer;
  color: #ffffff;
}

.flexStartBox {
  display: flex;
  justify-content: flex-start;
}

.approvalBgBox {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 15px 10px 0 0;
  text-align: center;
  background-color: #ffffff;
  position: relative;
}
.approvalBgBox i {
  color: #ffffff;
  font-size: 24px;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.data_box {
  border-radius: 15px;
  border: 1px solid #00a0e6;
  padding-bottom: 30px;
  margin: 20px 0;
}
.pandect {
  display: flex;
  justify-content: space-between;
  height: 220px;
  padding: 20px;
  /*margin-bottom: 20px;*/
}
.pandect p {
  line-height: 32px;
}
.pandect > div {
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.pandect .home_data_box {
  flex: 1;
  height: 160px;
  margin: 0 0 0 30px;
}
.pandect .home_data_statistics {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.home_data_statistics > div {
  width: 20%;
}
.data_main {
  font-weight: 700;
  font-size: 20px;
  color: #333333;
}
.data_title {
  font-weight: 400;
  color: #a6a6a6;
  font-size: 14px;
}
</style>

<style lang="less">
.flexStartBox {
  sup {
    top: 4px !important;
    right: 12px !important;
  }
}

.home-to-link-box {
  background-color: #ffffff;
  margin: 1px -20px 0;
  h3 {
    font-size: 20px;
    line-height: 40px;
  }
  .home-to-link-line-box {
    border: 1px solid #00a0e6;
    border-radius: 10px;
    margin: 10px 140px 20px;
    .home-to-link-line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 40px 20px;
      .home-to-link-item {
        width: 80px;
        height: 80px;
        border: 1px solid #cccccc;
        box-shadow: 0px 0px 10px 5px #cccccc;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        position: relative;
        .home-to-link-item-img {
          width: 35px;
          height: 35px;
        }
        .home-to-link-item-text {
          font-size: 14px;
          line-height: 25px;
        }
        .home-to-link-item-mask {
          width: 80px;
          height: 80px;
          position: absolute;
          top: 0;
          left: 0;
          background-color: #aaaaaa66;
          z-index: 80;
        }
      }

      .home-to-link-item:hover {
        border: 1px solid #00a0e6;
        box-shadow: 0px 0px 10px 4px #00a0e6;
      }
    }
  }

  .home-to-link-line-half-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin: 10px 140px;
    .home-to-link-line-half-box {
      width: 49%;
      border: 1px solid #00a0e6;
      border-radius: 10px;
      margin: 0 0 20px 0;
      .home-to-link-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 40px 20px;
        .home-to-link-item {
          width: 80px;
          height: 80px;
          border: 1px solid #cccccc;
          box-shadow: 0px 0px 10px 5px #cccccc;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          position: relative;
          .home-to-link-item-img {
            width: 35px;
            height: 35px;
          }
          .home-to-link-item-text {
            font-size: 14px;
            line-height: 25px;
          }
          .home-to-link-item-mask {
            width: 80px;
            height: 80px;
            position: absolute;
            top: 0;
            left: 0;
            background-color: #aaaaaa66;
            z-index: 80;
          }
        }
        .home-to-link-item:hover {
          border: 1px solid #00a0e6;
          box-shadow: 0px 0px 10px 3px #00a0e6;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Workbench/Workbench.vue